import React from 'react';

import { fetchInstructorProfile } from 'reduxModules/instructorProfile/action';
import { fetchInstructorProfileFlow } from 'reduxModules/instructorProfile/saga';
import { getInstructor } from 'reduxModules/instructorProfile/selector';

import Layout from 'components/Layout';

import InstructorProfile from './InstructorProfile';

async function action(context) {
  const {
    i18n,
    store,
    params: { id: idOfTypeString },
  } = context;

  const id = Number(idOfTypeString);

  await store
    .runSagas(fetchInstructorProfileFlow, fetchInstructorProfile({ id }))
    .toPromise();

  const { name: instructor } = getInstructor(store.getState());

  return {
    title: i18n.t('seo:seo.instructorProfile.individualPage.title', {
      instructor,
    }),
    description: i18n.t(
      'seo:seo.instructorProfile.individualPage.description',
      {
        instructor,
      },
    ),
    chunks: ['instructorProfile'],
    component: (
      <Layout>
        <InstructorProfile id={id} />
      </Layout>
    ),
  };
}

export default action;
